
import React, { useEffect, useState } from 'react';
import "./Order.css";
import { FaEye, FaTrash, FaFileExport, FaStar, FaFilter, FaChevronDown, FaSearch, FaTimes, FaPaperclip, FaCheckCircle } from "react-icons/fa";
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
const Order = () => {
  const [orders, setOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [filters, setFilters] = useState({
    name: "",
    orderType: "",
    paymentMethod: "",
    status: ""
  });
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [selectedYear, setSelectedYear] = useState("2025");
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedWeek, setSelectedWeek] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [showSupportPopup, setShowSupportPopup] = useState(false);
  const [showRatingPopup, setShowRatingPopup] = useState(false);
  const [orderId, setOrderId] = useState(null);
  const [ticketType, setTicketType] = useState("");
  const [message, setMessage] = useState("");
  const [imageBase64, setImageBase64] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [rating, setRating] = useState(0);
  const [feedback, setFeedback] = useState("");
  const [hoverRating, setHoverRating] = useState(0);
  const [isSubmittingRating, setIsSubmittingRating] = useState(false);

  const navigate = useNavigate();



  const itemsPerPage = 6;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentOrders = filteredOrders.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredOrders.length / itemsPerPage);

  // Filter options
  const orderTypeOptions = ["DINE_IN", "TAKEAWAY", "DELIVERY", "PICKUP"];
  const paymentOptions = ["CREDIT_CARD", "DEBIT_CARD", "UPI", "CASH", "WALLET"];
  const statusOptions = ["PENDING", "CONFIRMED", "PREPARING", "OUT_FOR_DELIVERY", "DELIVERED", "CANCELLED"];
  const ticketTypeOptions = [
    "DELIVERY_ISSUE",
    "PAYMENT_PROBLEM",
    "WRONG_ORDER",
    "SERVICE_QUALITY",
    "OTHER"
  ];

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const userId = localStorage.getItem('userId');
    const token = localStorage.getItem('authToken');

    if (!userId) {
      console.error('User ID not found in localStorage.');
      return;
    }

    axios.get(
      `https://backend.maamaas.com/food/api/orders/user/orders?userId=${userId}`,
      {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      }
    )
      .then(response => {
        const sortedOrders = response.data.sort(
          (a, b) => new Date(b.date) - new Date(a.date)
        );
        setOrders(sortedOrders);
        setFilteredOrders(sortedOrders);
      })
      .catch(error => {
        console.error('Error fetching orders:', error);
      });
  }, []);

  // Apply filters
  useEffect(() => {
    let result = orders;

    // Date filters
    if (selectedYear) {
      result = result.filter(order =>
        new Date(order.orderDateAndTime).getFullYear().toString() === selectedYear
      );
    }

    if (selectedMonth) {
      result = result.filter(order =>
        (new Date(order.orderDateAndTime).getMonth() + 1).toString() === selectedMonth
      );
    }

    if (selectedWeek) {
      result = result.filter(order =>
        getWeekOfMonth(order.orderDateAndTime).toString() === selectedWeek
      );
    }

    // Text filters
    if (filters.name) {
      result = result.filter(order =>
        order.dishName?.toLowerCase().includes(filters.name.toLowerCase())
      );
    }

    if (filters.orderType) {
      result = result.filter(order => order.orderType === filters.orderType);
    }

    if (filters.paymentMethod) {
      result = result.filter(order => order.paymentMethod === filters.paymentMethod);
    }

    if (filters.status) {
      result = result.filter(order => order.status === filters.status);
    }

    setFilteredOrders(result);
    setCurrentPage(1);
  }, [selectedYear, selectedMonth, selectedWeek, filters, orders]);

  const getWeekOfMonth = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    return Math.ceil(day / 7);
  };

  const handleFilterChange = (filterType, value) => {
    setFilters(prev => ({
      ...prev,
      [filterType]: value
    }));
  };

  const clearFilters = () => {
    setFilters({ name: "", orderType: "", paymentMethod: "", status: "" });
    setSelectedYear("2025");
    setSelectedMonth("");
    setSelectedWeek("");
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onloadend = () => {
      setImageBase64(reader.result.split(",")[1]);
    };
    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const handleSend = async () => {
    if (!ticketType || !message) {
      alert("Please fill in all required fields");
      return;
    }

    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("authToken");

    const payload = {
      ticketType,
      message,
      attachmentUrl: imageBase64 || null,
      userId,
    };

    try {
      const res = await fetch(
        ` https://backend.maamaas.com/food/api/tickets/create/${orderId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...(token && { Authorization: `Bearer ${token}` }),
          },
          body: JSON.stringify(payload),
        }
      );

      if (!res.ok) throw new Error("Failed to raise ticket");
      alert("Ticket raised successfully!");
      setShowSupportPopup(false);
      setOrderId(null);
      setTicketType("");
      setMessage("");
      setImageBase64("");
    } catch (err) {
      alert("Error: " + err.message);
    }
  };

  const openRatingPopup = (order) => {
    setSelectedOrder(order);
    setRating(order.rating || 0);
    setFeedback(order.feedback || "");
    setShowRatingPopup(true);
  };

  const closeRatingPopup = () => {
    setShowRatingPopup(false);
    setSelectedOrder(null);
    setRating(0);
    setFeedback("");
    setHoverRating(0);
  };

  const closeSupportPopup = () => {
    setShowSupportPopup(false);
    setOrderId(null);
    setTicketType("");
    setMessage("");
    setImageBase64("");
  };

  const submitRating = async () => {
    if (!selectedOrder) {
      alert("No order selected for rating.");
      return;
    }

    if (rating === 0) {
      alert("Please select a rating before submitting.");
      return;
    }

    setIsSubmittingRating(true);

    try {
      const userId = localStorage.getItem('userId');
      const token = localStorage.getItem('authToken');

      // Prepare the request payload
      const payload = {
        feedback: feedback || "",
        ratings: rating,
        ratedAt: new Date().toISOString(),
        userId: userId,
        orderId: selectedOrder.orderId
      };

      console.log("Submitting rating for order:", selectedOrder.orderId);
      console.log("Payload:", payload);

      // Try different endpoint patterns
      const endpoints = [
        ` https://backend.maamaas.com/food/api/orders/feedback/${selectedOrder.orderId}`,
        ` https://backend.maamaas.com/food/api/orders/${selectedOrder.orderId}/feedback`,
        ` https://backend.maamaas.com/food/api/orders/feedback`
      ];

      let success = false;
      let lastError = null;

      for (const endpoint of endpoints) {
        try {
          console.log("Trying endpoint:", endpoint);

          const response = await fetch(endpoint, {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              ...(token && { Authorization: `Bearer ${token}` }),
            },
            body: JSON.stringify(payload),
          });

          console.log("Response status:", response.status);

          if (response.ok) {
            const responseData = await response.json();
            console.log("Rating submitted successfully to:", endpoint);
            console.log("Response data:", responseData);

            // Update local state
            const updatedOrders = orders.map((o) =>
              o.orderId === selectedOrder.orderId
                ? {
                  ...o,
                  rating: rating,
                  feedback: feedback || "",
                  ratedAt: payload.ratedAt
                }
                : o
            );

            setOrders(updatedOrders);
            setFilteredOrders(updatedOrders);


            success = true;
            break;
          } else {
            const errorText = await response.text();
            console.error(`Server error from ${endpoint}:`, errorText);
            lastError = new Error(`Server responded with status: ${response.status}`);
          }
        } catch (err) {
          console.error(`Error with endpoint ${endpoint}:`, err);
          lastError = err;
        }
      }

      if (!success) {
        throw lastError || new Error("Failed to submit rating through all endpoints");
      }

      closeRatingPopup();

    } catch (error) {
      console.error('Error submitting rating:', error);
      alert(`Failed to submit rating. Please try again. Error: ${error.message}`);
    } finally {
      setIsSubmittingRating(false);
    }
  };

  const renderStars = (currentRating, interactive = false) => {
    return (
      <div className="stars-container">
        {[1, 2, 3, 4, 5].map((num) => (
          <span
            key={num}
            className={`star ${interactive ? 'interactive' : ''}`}
            style={{
              color: num <= (interactive ? hoverRating || rating : currentRating) ? "gold" : "#ccc",
              cursor: interactive ? "pointer" : "default",
              fontSize: interactive ? "32px" : "16px",
              marginRight: interactive ? "8px" : "2px"
            }}
            onClick={() => interactive && setRating(num)}
            onMouseEnter={() => interactive && setHoverRating(num)}
            onMouseLeave={() => interactive && setHoverRating(0)}
          >
            ★
          </span>
        ))}
      </div>
    );
  };

  const getStatusColor = (status) => {
    const statusColors = {
      PENDING: "#f39c12",
      CONFIRMED: "#3498db",
      PREPARING: "#ee6521",
      OUT_FOR_DELIVERY: "#e67e22",
      DELIVERED: "#27ae60",
      CANCELLED: "#e74c3c"
    };
    return statusColors[status] || "#95a5a6";
  };

  const getPaymentIcon = (method) => {
    const icons = {
      CREDIT_CARD: "💳",
      DEBIT_CARD: "💳",
      UPI: "📱",
      CASH: "💵",
      WALLET: "👛"
    };
    return icons[method] || "💳";
  };

  return (
    <div className="order-container">
      {/* Header Section */}
      <div className="order-header">
        {/* <div className="header-content">
          <h2>My Orders</h2>
          <p>View and manage your order history</p>
        </div> */}
      </div>

      {/* Filters Section */}
      <div className="order-filters-wrapper">
        <div className="order-advanced-filters">
          <button
            className="order-filter-toggle-btn"
            onClick={() => setIsFilterOpen(!isFilterOpen)}
          >
            <FaFilter />
            Advanced Filters
            <FaChevronDown className={isFilterOpen ? "order-rotate" : ""} />
          </button>

          <button className="order-clear-filters-btn" onClick={clearFilters}>
            Clear Filters
          </button>
        </div>

        {isFilterOpen && (
          <div className="order-filter-dropdown">
            <div className="order-filter-grid">
              <div className="order-date-filters">
                <div className="order-filter-group">
                  <select
                    value={selectedYear}
                    onChange={(e) => setSelectedYear(e.target.value)}
                  >
                    <option value="">Years</option>
                    <option value="2024">2024</option>
                    <option value="2023">2023</option>
                    <option value="2022">2022</option>
                    <option value="2025">2025</option>
                  </select>
                </div>

                <div className="order-filter-group">
                  <select
                    value={selectedMonth}
                    onChange={(e) => setSelectedMonth(e.target.value)}
                  >
                    <option value="">Months</option>
                    <option value="1">January</option>
                    <option value="2">February</option>
                    <option value="3">March</option>
                    <option value="4">April</option>
                    <option value="5">May</option>
                    <option value="6">June</option>
                    <option value="7">July</option>
                    <option value="8">August</option>
                    <option value="9">September</option>
                    <option value="10">October</option>
                    <option value="11">November</option>
                    <option value="12">December</option>
                  </select>
                </div>

                <div className="order-filter-group">
                  <select
                    value={selectedWeek}
                    onChange={(e) => setSelectedWeek(e.target.value)}
                  >
                    <option value="">Weeks</option>
                    <option value="1">Week 1</option>
                    <option value="2">Week 2</option>
                    <option value="3">Week 3</option>
                    <option value="4">Week 4</option>
                    <option value="5">Week 5</option>
                  </select>
                </div>
              </div>

              <div className="order-filter-field">
                <select
                  value={filters.orderType}
                  onChange={(e) => handleFilterChange("orderType", e.target.value)}
                >
                  <option value="">Order Types</option>
                  {orderTypeOptions.map(type => (
                    <option key={type} value={type}>{type.replace('_', ' ')}</option>
                  ))}
                </select>
              </div>

              <div className="order-filter-field">
                <select
                  value={filters.paymentMethod}
                  onChange={(e) => handleFilterChange("paymentMethod", e.target.value)}
                >
                  <option value="">Payment Methods</option>
                  {paymentOptions.map(method => (
                    <option key={method} value={method}>{method.replace('_', ' ')}</option>
                  ))}
                </select>
              </div>

              <div className="order-filter-field">
                <select
                  value={filters.status}
                  onChange={(e) => handleFilterChange("status", e.target.value)}
                >
                  <option value="">Order Status</option>
                  {statusOptions.map(status => (
                    <option key={status} value={status}>{status.replace('_', ' ')}</option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Orders Table/Cards */}
      <div className="orders-content">
        {isMobile ? (
          // Mobile Cards View
          <div className="orders-cards">
            {currentOrders.length > 0 ? (
              currentOrders.map((order, index) => (
                <div key={index} className="order-card">
                  <div className="card-header">
                    <div className="order-id">#{order.orderId}</div>
                    <div
                      className="order-status"
                      style={{ backgroundColor: getStatusColor(order.status) }}
                    >
                      {order.status?.replace('_', ' ') || 'PENDING'}
                    </div>
                  </div>

                  <div className="card-content">
                    <div className="order-info">
                      <div className="info-row">
                        <span className="label">Date & Time:</span>
                        <span className="value">
                          {new Date(order.orderDateAndTime).toLocaleDateString()} •
                          {new Date(order.orderDateAndTime).toLocaleTimeString([], {
                            hour: '2-digit', minute: '2-digit'
                          })}
                        </span>
                      </div>

                      <div className="info-row">
                        <span className="label">Item:</span>
                        <span className="value">{order.dishName}</span>
                      </div>

                      <div className="info-row">
                        <span className="label">Type:</span>
                        <span className="value">{order.orderType?.replace('_', ' ')}</span>
                      </div>

                      <div className="info-row">
                        <span className="label">Payment:</span>
                        <span className="value payment-method">
                          {getPaymentIcon(order.paymentMethod)}
                          {order.paymentMethod?.replace('_', ' ')}
                        </span>
                      </div>

                      <div className="info-row">
                        <span className="label">Amount:</span>
                        <span className="value amount">₹{Number(order.grandTotal).toFixed(0)}</span>
                      </div>

                      <div className="info-row">
                        <span className="label">Rating:</span>
                        <span className="value">
                          {order.rating ? renderStars(order.rating) : "Not rated"}
                        </span>
                      </div>

                      <div className="info-row">
                        <span className="label">Feedback:</span>
                        <span className="value feedback-preview">
                          {order.feedback ?
                            (order.feedback.length > 30 ? order.feedback.substring(0, 30) + '...' : order.feedback)
                            : "No feedback"}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="card-actions">
                    <button
                      className="rate-btn"
                      onClick={() => openRatingPopup(order)}
                    >
                      <FaStar />
                      {order.rating ? "Update Rating" : "Rate Order"}
                    </button>
                    <button
                      className="support-btn"
                      onClick={() => {
                        setShowSupportPopup(true);
                        setOrderId(order.orderId);
                      }}
                    >
                      <FaCheckCircle />
                      Get Support
                    </button>
                    onClick={() => {
                      const vId = order.vendorId || order.vendor_id;
                      if (!vId) {
                        alert("Vendor ID missing");
                        return;
                      }
                      navigate(`/Newmenuiteam/${vId}`);
                    }}
                  </div>
                </div>
              ))
            ) : (
              <div className="empty-state">
                <div className="empty-icon">📦</div>
                <h3>No Orders Found</h3>
                <p>Try adjusting your filters or check back later</p>
              </div>
            )}
          </div>
        ) : (
          // Desktop Table View
          <div className="orders-table-container">
            <table className="orders-table">
              <thead>
                <tr>
                  <th>Order ID</th>
                  <th>Date & Time</th>
                  <th>Item</th>
                  <th>Type</th>
                  <th>Payment</th>
                  {/* <th>Status</th> */}
                  <th>Amount</th>
                  <th>Rating</th>
                  <th>Feedback</th>
                  <th>Actions</th>
                </tr>
              </thead>

              <tbody>
                {currentOrders.length > 0 ? (
                  currentOrders.map((order, index) => (
                    <tr key={index} style={{ textAlign: "left" }}>
                      <td className="order-id">#{order.orderId}</td>

                      <td className="datetime">
                        <div>{new Date(order.orderDateAndTime).toLocaleDateString()}</div>
                        <div className="time">
                          {new Date(order.orderDateAndTime).toLocaleTimeString([], {
                            hour: "2-digit",
                            minute: "2-digit",
                          })}
                        </div>
                      </td>

                      <td>{order.order?.[0]?.dishName}</td>

                      <td>{order.orderType?.replace("_", " ")}</td>
                      <td>{order.paymentMethod?.replace("_", " ")}</td>

                      {/* <td>
                        <span
                          className="status-badge"
                          style={{ backgroundColor: getStatusColor(order.status) }}
                        >
                          {order.status?.replace("_", " ") || "PENDING"}
                        </span>
                      </td> */}

                      <td>₹{Number(order.grandTotal).toFixed(0)}</td>

                      {/* Rating column */}
                      <td>
                        {order.rating ? (
                          <div className="rating-display">
                            {renderStars(order.rating)}
                            <span className="rating-number">({order.rating}/5)</span>
                          </div>
                        ) : (
                          <span className="not-rated">Not rated</span>
                        )}
                      </td>

                      {/* Feedback column */}
                      <td>
                        {order.feedback ? (
                          <div className="feedback-cell" title={order.feedback}>
                            {order.feedback.length > 50
                              ? order.feedback.substring(0, 50) + '...'
                              : order.feedback}
                          </div>
                        ) : (
                          <span className="no-feedback">—</span>
                        )}
                      </td>

                      {/* Actions */}
                      <td>
                        <div className="actions-container">
                          <button
                            className="rate-action-btn"
                            onClick={() => openRatingPopup(order)}
                          >
                            <FaStar />
                            {order.rating ? "Update" : "Rate"}
                          </button>

                          <button
                            className="support-action-btn"
                            onClick={() => {
                              setShowSupportPopup(true);
                              setOrderId(order.orderId);
                            }}
                          >
                            <FaCheckCircle />
                            Support
                          </button>

                          <button
                            className="reorder-btn"
                            onClick={() => {
                              const vId = order.vendorId || order.vendor_id;
                              if (!vId) {
                                alert("Vendor ID missing");
                                return;
                              }
                              navigate(`/Newmenuiteam/${vId}`);
                            }}
                          >
                            Reorder
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="10" className="no-orders">
                      No Orders Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}

        {/* Pagination */}
        {filteredOrders.length > 0 && (
          <div className="pagination">
            <button
              onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              className="pagination-btn prev"
            >
              Previous
            </button>

            <div className="page-info">
              Page {currentPage} of {totalPages}
            </div>

            <button
              onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
              disabled={currentPage === totalPages}
              className="pagination-btn next"
            >
              Next
            </button>
          </div>
        )}
      </div>

      {/* Rating Popup */}
      {showRatingPopup && selectedOrder && (
        <div className="popup-overlay">
          <div className="popup-box">
            <div className="popup-header">
              <h3>Rate Your Order #{selectedOrder.orderId}</h3>
              <button className="close-popup-btn" onClick={closeRatingPopup}>
                <FaTimes />
              </button>
            </div>

            <div className="popup-content">
              {/* <div className="order-info-popup">
                <p><strong>Item:</strong> {selectedOrder.dishName}</p>
                <p><strong>Date:</strong> {new Date(selectedOrder.orderDateAndTime).toLocaleDateString()}</p>
                <p><strong>Amount:</strong> ₹{Number(selectedOrder.grandTotal).toFixed(0)}</p>
              </div> */}

              <div className="rating-section">
                <h4>How would you rate this order?</h4>
                <div className="stars-rating">
                  {renderStars(rating, true)}
                </div>
                <div className="rating-labels">
                  <span>Poor</span>
                  <span>Excellent</span>
                </div>
              </div>

              <div className="feedback-section">
                <h4>Your Feedback (Optional)</h4>
                <textarea
                  className="feedback-textarea"
                  placeholder="Share your experience with this order..."
                  value={feedback}
                  onChange={(e) => setFeedback(e.target.value)}
                  rows="4"
                />
              </div>
            </div>

            <div className="popup-actions">
              <button
                className="submit-rating-btn"
                onClick={submitRating}
                disabled={isSubmittingRating}
              >
                {isSubmittingRating ? "Submitting..." : "Submit Rating"}
              </button>
              <button
                onClick={closeRatingPopup}
                className="cancel-rating-btn"
                disabled={isSubmittingRating}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Support Ticket Modal */}
      {showSupportPopup && (
        <div className="modal-overlay">
          <div className="modal-contenty">
            <div className="modal-header">
              <h2>Raise Support Ticket</h2>
              <button className="close-btn" onClick={closeSupportPopup}>
                <FaTimes />
              </button>
            </div>

            <div className="modal-body">
              <div className="order-reference">
                <strong>Order ID:</strong> #{orderId}
              </div>

              <div className="form-group">
                <label>Ticket Type *</label>
                <select
                  value={ticketType}
                  onChange={(e) => setTicketType(e.target.value)}
                  className="form-select"
                >
                  <option value="">Select issue type</option>
                  {ticketTypeOptions.map(type => (
                    <option key={type} value={type}>
                      {type.replace('_', ' ')}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>Message *</label>
                <textarea
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder="Please describe your issue in detail..."
                  className="form-textarea"
                  rows="4"
                />
              </div>

              <div className="form-group">
                <label>Attachment</label>
                <div className="file-upload">
                  <input
                    type="file"
                    onChange={handleImageUpload}
                    accept="image/*"
                    id="file-upload"
                  />
                  <label htmlFor="file-upload" className="file-upload-label">
                    <FaPaperclip />
                    Choose File
                  </label>
                  {imageBase64 && <span className="file-name">Image selected</span>}
                </div>
              </div>
            </div>

            <div className="modal-actions">
              <button
                className="cancel-btn"
                onClick={closeSupportPopup}
              >
                Cancel
              </button>
              <button
                className="send-btny"
                onClick={handleSend}
                disabled={!ticketType || !message}
              >
                <FaCheckCircle />
                Send Ticket
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Order;